'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

import { Button } from '@/components/ui/button';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="de">
      <body className="bg-background">
        <div className="flex min-h-screen items-center justify-center px-4 py-12">
          <div className="max-w-md space-y-4 text-center">
            <h1 className="font-semibold text-2xl text-aareal-aval">Ein Fehler ist aufgetreten</h1>
            <p className="text-muted-foreground text-sm">
              Die Seite konnte gerade nicht geladen werden. Bitte versuchen Sie es erneut.
            </p>
            <div className="flex justify-center">
              <Button
                className="bg-aareal-aval hover:bg-aareal-aval-light"
                onClick={reset}
                type="button"
              >
                Erneut versuchen
              </Button>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
